/* COPYRIGHT Esri - https://js.arcgis.com/5.1.20/LICENSE.txt */
function e(e){e.vertex.code.add("#define noPerspectiveWrite(x, w) (x * w)")}function d(e){e.fragment.code.add("#define noPerspectiveRead(x) (x * gl_FragCoord.w)")}export{d as NoPerspectiveRead,e as NoPerspectiveWrite};
